export default "__VITE_ASSET__B0joJd2S__"